import request from "../request";

export type ProjectPaymentNodeItem = {
  ID: number;
  name: string;
  startTime: string;
  contcollPlan: string;
  contractName: string;
  salesContractCode: string;
};

/**
 * 获取合同的收款节点
 */
export const getProjectPaymentNodes = async (projectID: number | string, contractCode: string): Promise<API.PROJECT.ContractPayNode[]> => {
  const params = {
    contractCode: contractCode
  }
  return await request.get(`/workbenchApi/projects/${projectID}/nodes`, {params});
};
export const getProjectMultiplePaymentNodes = async (projectID: number | string, contractCodes: string[]): Promise<{[contractCode: string]: API.PROJECT.ContractPayNode[]}> => {
  const params = {
    contractCodes: contractCodes
  }
  return await request.get(`/workbenchApi/projects/${projectID}/nodes/multiple`, { params });
};
export const getProjectPaymentContractNodesApi = async (projectID: number | string): Promise<API.PROJECT.SalesContractNode[]> => {
  return await request.get(`/workbenchApi/integrateds/projects/${projectID}/contract-nodes`);
};
// 总包项目下所有的收款合同
export const getProjectPaymentAllContractNodesApi = async (projectID: number | string): Promise<API.PROJECT.SalesContractNode[]> => {
  return await request.get(`/workbenchApi/integrateds/projects/${projectID}/gc-contracts`);
};
/**
 * 获取合同的收款节点和付款节点的关联
 */
export const getProjectPaymentExpenseLinks = async (projectID: number | string): Promise<API.PROJECT.PaymentExpenseLink[]> => {
  return await request.get(`/workbenchApi/integrateds/projects/${projectID}/payment-receipts`);
};
/**
 * 更新合同的收款节点和付款节点的关联
 */
export const updateProjectPaymentExpenseLinks = async (projectID: number | string, data: Request.PaymentExpenseLink[]): Promise<{ [contractCode: string]: API.PROJECT.ContractPayNode[] }> => {
  return await request.post(`/workbenchApi/integrateds/projects/${projectID}/payment-receipts`, {
    receipts: data
  });
};